<template>
  <div class="row">
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Agregar Categorías</h3>
        </div>
        <div class="panel-body">
          <table class="table table-condensed table-bordered">
            <tr>
              <th>Nombre</th>
              <th>Código</th>
              <th>Acciones</th>
            </tr>
            <tr v-for="category in categories">
              <td>{{ category.name }}</td>
              <td>{{ category.code }}</td>
              <td>
                <button type="button" class="btn btn-default" @click="addCategory(category)">
                  <span class="glyphicon glyphicon-check" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="panel panel-info">
        <div class="panel-heading">
          <h3 class="panel-title">Categorías seleccionadas</h3>
        </div>
        <div class="panel-body">
          <table class="table table-condensed table-bordered">
            <tr>
              <th>Nombre</th>
              <th>Código</th>
              <th>Acciones</th>
            </tr>
            <tr v-for="category in selected_categories">
              <td>{{ category.name }}</td>
              <td>{{ category.code }}</td>
              <td>
                <button type="button" class="btn btn-danger" @click="deleteCategory(category)">
                  <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
                </button>
                <button type="button" class="btn btn-primary" @click="configureCategory(category)">
                  <span class="glyphicon glyphicon-cog" aria-hidden="true"></span>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import configure from '../../configure'
  import {modal} from 'vue-strap'
  import * as actions from '../../vuex/actions'
  import {
    getConfigChampionship,
    getConfigCategories
  } from '../../vuex/getters'

  export default{
    components: {modal},
    vuex: {
      getters: {
        championship: getConfigChampionship,
        selected_categories: getConfigCategories
      },
      actions: actions
    },
    data() {
      return {
        categories: [],
        category: '',
      }
    },
    ready() {
      this.fetchCategories();
    },
    methods: {
      fetchCategories() {
        this.setLoading(true);
        this.$http.get(
          configure.api_url + 'global_categories'
        ).then((response) => {
          this.categories = response.data;
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error fetching categories'})
        })
      },
      addCategory(category) {
        this.setLoading(true);
        let selected_categories = this.selected_categories;
        category.championship_id = this.championship.id;
        this.$http.post(
          configure.api_url + 'categories',
          category
        ).then((response) => {
          selected_categories.push(response.data);
          this.setConfigCategories(selected_categories);
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Error saving category'})
        })

      },
      deleteCategory(category) {
        this.setLoading(true);
        let selected_categories = this.selected_categories;
        this.$http.delete(
          configure.api_url + 'categories/' + category.id
        ).then((response) => {
          selected_categories.$remove(category);
          this.setConfigCategories(selected_categories);
          this.setLoading(false);
        }, (error) => {
          this.setLoading(false);
          this.setError({show: true, message:'Esta categoría tiene jugadores inscritos'})
        })
      }
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** Categories.vue?c86e5c74
 **/